<template>
  <main role="main" class="col content-spacing">
    <div
      class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
    >
      <h1 class="h2">Calculos</h1>
      <div class="btn-toolbar mb-2 mb-md-0">
        <div class="btn-group mr-2"></div>
      </div>
    </div>
    <div class="table-content">
      <b-table striped hover :items="items" :fields="fields">
        <template #cell(totalAmountDistributor)="data">
          <span>R$ {{ formatCurrency(data.item.totalAmountDistributor) }}</span>
        </template>
        <template #cell(totalCredit)="data">
          <span>R$ {{ formatCurrency(data.item.totalCredit) }}</span>
        </template>
        <template #cell(economy)="data">
          <span>R$ {{ formatCurrency(data.item.economy) }}</span>
        </template>
        <template #cell(ticketVeins)="data">
          <span>R$ {{ formatCurrency(data.item.ticketVeins) }}</span>
        </template>
        <template #cell(moneyTransferPlant)="data">
          <span>R$ {{ formatCurrency(data.item.moneyTransferPlant) }}</span>
        </template>
        <template #cell(moneyGrossRevenueVeins)="data">
          <span>R$ {{ formatCurrency(data.item.moneyGrossRevenueVeins) }}</span>
        </template>
        <template #cell(percentGrossRevenueVeins)="data">
          <span>{{ data.item.percentGrossRevenueVeins.toFixed(2) }}</span>
        </template>
        <template #cell(energyTariff)="data">
          <span>R$ {{ formatCurrency(data.item.energyTariff) }}</span>
        </template>
        <template #cell(injectedRate)="data">
          <span>R$ {{ formatCurrency(data.item.injectedRate) }}</span>
        </template>
      </b-table>
    </div>
  </main>
</template>

<script>
import helpers from '../../vue/helpers';
import { Api } from '../../vue/api';
const API = new Api();

export default {
  data() {
    return {
      fields: [
        {
          key: 'installationId',
          label: 'Instalação',
        },
        {
          key: 'site',
          label: 'Consumidor',
        },
        {
          key: 'status',
          label: 'Cobrança',
        },
        {
          key: 'dueDateVeins',
          label: 'Vencimento Veins',
        },
        {
          key: 'dueDateDistributor',
          label: 'Vencimento Distribuidora',
        },
        {
          key: 'totalAmountDistributor',
          label: 'Fatura Distribuidora',
        },
        {
          key: 'totalCredit',
          label: 'Crédito total',
        },
        {
          key: 'percentGuaranteedDiscount',
          label: 'Desconto garantido (%)',
        },
        {
          key: 'economy',
          label: 'Economia',
        },
        {
          key: 'ticketVeins',
          label: 'Boleto Veins',
        },
        {
          key: 'percentTransferPlant',
          label: 'Repasse Usina (%)',
        },
        {
          key: 'moneyTransferPlant',
          label: 'Repasse Usina (R$)',
        },
        {
          key: 'moneyGrossRevenueVeins',
          label: 'Receita Bruta Veins (R$)',
        },
        {
          key: 'percentGrossRevenueVeins',
          label: 'Receita Bruta Veins (%)',
        },
        {
          key: 'energyTariff',
          label: 'Tarifa Energia (R$/kWh)',
        },
        {
          key: 'injectedRate',
          label: 'Tarifa Injetada (R$/kWh)',
        },
        {
          key: 'totalConsumption',
          label: 'Consumo Total (kWh)',
        },
        {
          key: 'distributionEnergy',
          label: 'Energia Distribuidora (kWh)',
        },
        {
          key: 'injectedEnergy',
          label: 'Energia Injetada (kWh)',
        },
        {
          key: 'compensatedEnergy',
          label: 'Energia Compensada (kWh)',
        },
        {
          key: 'accumulatedBalance',
          label: 'Saldo Acumulado (kWh)',
        },
        {
          key: 'tariffType',
          label: 'Modalidade Tarifária',
        },
        {
          key: 'class',
          label: 'Classe',
        },
        {
          key: 'subClass',
          label: 'Subclasse',
        },
        {
          key: 'billClass',
          label: 'Fase',
        },
        {
          key: 'energyProvider',
          label: 'Distribuidora',
        },
        {
          key: 'percentStandardDiscount',
          label: 'Desconto Padrão (%)',
        },
        {
          key: 'percentDiscountCoupon',
          label: 'Desconto Cupom (%)',
        },
        {
          key: 'insertedAt',
          label: 'Inserido em',
        },
        {
          key: 'readingDate',
          label: 'Lido em',
        },
        {
          key: 'previousReading',
          label: 'Leitura anterior',
        },
        {
          key: 'nextReading',
          label: 'Próxima leitura',
        },
        {
          key: 'id',
          label: 'ID',
        },
        {
          key: 'sdpId',
          label: 'SDPID',
        },
        {
          key: 'referenceDate',
          label: 'Data referência',
        },
      ],
      items: [],
    };
  },

  beforeMount: async function() {
    console.log('teste');
    await this.getBillsByExcelFormat();
  },

  methods: {
    async getBillsByExcelFormat() {
      this.$router.push({
        query: { page: 1, limit: 1000 },
      });
      const result = await API.post('/execute', {
        path: '/calculation-cemig' + helpers.toQueryString(this.$route.query),
        method: 'get',
      });
      // const result = await axios.get('https://api.way2.com.br/v1/bills/details?toExcelFormat=1&subscriptionid=63414496-4a05-4830-9faf-45855a438cd0&sdpid=701b758e-8929-4d28-a702-6d923db22e42&monthStart=2023-01-01&apiKey=f75873ca5ac14b1daae8bfdb3251033c')
      // for (const item of result.data) {
      //   this.items.push(this.billsByExcelDTO(item))
      // }
    },

    formatCurrency(value) {
      if (value) {
        return value.toLocaleString('pt-BR', {
          currency: 'BRL',
          minimumFractionDigits: 1,
        });
      }
    },
  },
};
</script>

<style scoped>
.table-content {
  padding: 2rem;
  white-space: nowrap;
  width: 100%;
  margin-bottom: 1rem;
  margin-top: 1rem;
  height: 22rem;
  overflow-x: auto;
  overflow-y: auto;
}
.table-content table thead {
  position: sticky;
  top: -23px;
  z-index: 1;
  background-color: #fff;
  border-right: 1px solid gray;
}

.table-content table tbody {
  margin-top: 2rem;
}

.table-content table {
  display: contents;
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

.table-content .table td {
  padding: 0.5rem !important;
  vertical-align: inherit !important;
}
</style>
